export enum PeeringTab {
  Configuration = "Configuration",
  Review = "Review",
}
